<h1
  mat-dialog-title
  class="tw-text-gray-800 dark:tw-text-gray-200 tw-text-2xl tw-px-0 tw-mb-4 tw-flex tw-items-center tw-gap-2">
  <mat-icon class="tw-text-orange-500">bug_report</mat-icon>
  Thread Details (Admin)
</h1>

<div mat-dialog-content class="tw-mb-3 tw-min-h-[400px] tw-max-h-[70vh] tw-overflow-auto">
  <div class="tw-space-y-6">
    <!-- Thread Object from getChat API -->
    <div *ngIf="data.thread">
      <h3
        class="tw-text-lg tw-font-semibold tw-text-gray-800 dark:tw-text-gray-200 tw-mb-2 tw-flex tw-items-center tw-gap-2">
        <mat-icon class="tw-text-blue-500">chat</mat-icon>
        Thread Object (getChat API)
      </h3>
      <ngx-json-treeview [json]="data.thread" [depth]="3" [expanded]="false"></ngx-json-treeview>
    </div>

    <!-- Admin Thread Details -->
    <div *ngIf="data.adminThread">
      <h3
        class="tw-text-lg tw-font-semibold tw-text-gray-800 dark:tw-text-gray-200 tw-mb-2 tw-flex tw-items-center tw-gap-2">
        <mat-icon class="tw-text-orange-500">admin_panel_settings</mat-icon>
        Admin Thread Details
      </h3>
      <ngx-json-treeview
        [json]="data.adminThread"
        [depth]="3"
        [expanded]="false"></ngx-json-treeview>
    </div>

    <!-- Fallback for old format (direct data without structure) -->
    <div *ngIf="!data.thread && !data.adminThread">
      <ngx-json-treeview [json]="data" [depth]="3" [expanded]="false"></ngx-json-treeview>
    </div>
  </div>
</div>

<div mat-dialog-actions class="tw-flex tw-justify-between">
  <button mat-stroked-button (click)="close()">Close</button>
  <button mat-raised-button color="primary" (click)="copyToClipboard()">
    <mat-icon class="tw-mr-1">content_copy</mat-icon>
    Copy JSON
  </button>
</div>
